require('/opt/odin/app/frontend/components/modals/setup/index.module.scss');module.exports = "../../app/cells/components/modals/setup/redirect.erb";